import React, { forwardRef } from 'react';
import { Desc } from '../../../promotions/view/components/FormTypography';
import { Toggle } from '@client/components/common/inputs/Toggle';
import { Option } from '@client/new/helpers/types';
import { Row } from '@design-system/components/grid/grid';
import { Tooltip } from '@design-system/components/tooltip/tooltip';

// Extend your Option<string> with the other props needed
type ToggleDescriptionProps = Option<string> & {
  onChange: (event: React.ChangeEvent<HTMLInputElement> | any) => void;
  tooltip?: string;
  disabled?: boolean;
  name: string;
};

export const ToggleDescription = forwardRef<
  HTMLDivElement,
  ToggleDescriptionProps
>((props, ref) => {
  const { onChange, tooltip, disabled, name, value, label } = props;

  const row = (
    <Row
      ref={ref}
      alignCenter
      style={disabled ? { opacity: '0.3' } : {}}
      onClick={() => {
        if (disabled) return;
        const event = {
          target: { name, value: !value },
        } as any;
        onChange(event);
      }}
    >
      <Desc>{label}</Desc>
      <Toggle value={value} />
    </Row>
  );

  return tooltip ? (
    <Tooltip
      title={tooltip}
      variant="dark"
      arrow
      tooltipProps={{
        maxWidth: '160px',
      }}
    >
      {row}
    </Tooltip>
  ) : (
    row
  );
});

ToggleDescription.displayName = 'ToggleDescription';
